import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=58db90ef"
import script from "./FaqEdit.vue?vue&type=script&lang=js"
export * from "./FaqEdit.vue?vue&type=script&lang=js"
import style0 from "./FaqEdit.vue?vue&type=style&index=0&id=58db90ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports